import classNames from 'classnames'
import { Popup } from '../popup'
import styles from './Coachmark.module.scss'
import type { CoachmarkProps } from './types'

const Coachmark = ({ className, children, ...rest }: CoachmarkProps) => {
  return (
    <Popup role="alert" {...rest} className={classNames(styles['pintxo-coachmark'], className)}>
      <span className={'caret'}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="12"
          viewBox="0 0 18 12"
          fill="none"
        >
          <path d="M10.6641 9.50385C9.87246 10.6913 8.12754 10.6913 7.3359 9.50385L0.999999 -4.4509e-07L17 9.53674e-07L10.6641 9.50385Z" />
          <path
            d="M1 0.5H1.47059L7.30587 9.79999C8.08978 11.0493 9.91022 11.0493 10.6941 9.79998L16.5294 0.5H17"
            stroke="#CDCED0"
            className={'caret__border'}
            strokeLinecap="square"
          />
        </svg>
      </span>
      {children}
    </Popup>
  )
}

export default Coachmark
